import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/config";
import { errorMessage } from "./useMember";

/** Shared submit handler for the three application forms. */
export const useSubmitApplication = ({ path, headers, onCreated, clearDraft }) => {
  const [busy, setBusy] = useState(false);
  const submit = async (payload, successName) => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/applications/${path}`, payload, { headers });
      clearDraft();
      onCreated(data.applicant);
      toast.success(`Application received. Welcome aboard, ${successName}.`);
    } catch (err) {
      toast.error(errorMessage(err, "Application failed to send — try again."));
    } finally {
      setBusy(false);
    }
  };
  return { busy, submit };
};
